// search-dropdown.js 			~/js/
////////////////////////////////////////////////////////////

// Activate Search-dropdown
const searchButton = document.querySelector('a.search-button-container');
const searchDropdown = document.querySelector('div.search-dropdown');
const searchAgainInput = document.getElementById('search');
const searchDropdownInput = searchDropdown.querySelector(
  '.search-dropdown input',
);

if (searchAgainInput) {
  searchAgainInput.selectionStart = searchAgainInput.selectionEnd =
    searchAgainInput.value.length;

  searchAgainInput.focus();

  searchButton.addEventListener('click', function (e) {
    searchAgainInput.focus();
    searchAgainInput.select();
    e.preventDefault();
  });
} else {
  searchButton.addEventListener('click', function (e) {
    if (!searchAgainInput) {
      searchDropdown.classList.toggle('is-active');
    }

    searchDropdownInput.focus();

    e.preventDefault();
  });
}
